export default __webpack_public_path__ + "static/media/03_INDIA-1poinrt5-768x517.f85ed233.jpg";